import { Grid, Container, Tab, Box, IconButton, Tooltip } from '@mui/material';
import { GridColDef, DataGrid } from '@mui/x-data-grid';
import React, { useState } from 'react'
import { useAppContext } from '../../../../libs/app-core/AppContext';
import { Toast } from '../../../../libs/app-core/Toast';
import { linear_v, linear_item, linear_content_style } from '../../../../libs/linear-layout/LinearLayout';
import Label from '../../../../libs/rhf-mui/ui/Label';
import AppBarTabs from '../../../components/AppBarTabs';
import TabPage from '../../../components/TabPage';
import UcDgvCustomPagination from '../../../components/UcDgvCustomPagination';
import UcDgvCustomToolbar from '../../../components/UcDgvCustomToolbar';
import { render_ToolTipCell, DGV_LOCAL_TEXT } from '../../../components/UIHelper';
import { UniFunc } from '../../../dao/UniFunc';
import { HisRowDto } from '../../../export_spwk/HisDtoManager/HisDto';
import { SpwkToHisInfo } from '../SpwkToHisInfo';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { SpwkUtil } from '../../../dao/SpwkUtil';
import { UniOption } from '../../../dao/UniOption';

type Props = {
  /** 左側選單 Focus 的轉檔結果 */
  CurrInfo: SpwkToHisInfo | undefined;

  /* 篩選: 特作編號 (此轉檔結果，繼續篩選，只看到指定特作) */
  CurrUniFunc: UniFunc | null;
}

const UcHisRowDto = ({ CurrInfo, CurrUniFunc, ...props }: Props) => {

  const ctx = useAppContext();

  const [CurrTabIndex, set_CurrTabIndex] = useState("tab_Table");

  let data_list = CurrInfo?.HisDto?.問卷明細 ?? [];
  if (CurrUniFunc != null) {
    data_list = data_list.filter(x => x.作業編號 === CurrUniFunc.func_code);
  }

  const json = JSON.stringify(data_list, null, 4);
  return (
    <Grid {...linear_v}>

      {/* 上方控制區 */}
      <Grid {...linear_item}>
        <Container >
          {render_Tabs()}
        </Container>
      </Grid>

      {/* 下方內容區 */}
      <Grid {...linear_item} flex={1} sx={{}}>
        {render_TabControl()}
      </Grid>

    </Grid>
  )

  function render_Tabs() {
    return (
      <Container  >
        <AppBarTabs AppBarTabIndex={CurrTabIndex} set_AppBarTabIndex={set_CurrTabIndex} is_light_bg={true}>
          <Tab label="[UcHisRowDto] Table" value={"tab_Table"} />
          <Tab label="JSON" value={"tab_JSON"} />
        </AppBarTabs>
      </Container>
    );
  }

  function render_TabControl() {
    return (
      <Box style={linear_content_style} sx={{ height: "100%", bgcolor: "" }}>
        <TabPage tab_key={"tab_Table"} curr_tab={CurrTabIndex} sx={{ bgcolor: "", height: "100%", overflow: 'hidden' }}>
          <Box sx={{ height: "100%", bgcolor: "" }}>
            {render_DataGrid()}
          </Box>
        </TabPage>

        <TabPage tab_key={"tab_JSON"} curr_tab={CurrTabIndex} sx={{}}>
          <Container >
            <Label>{json}</Label>
          </Container>
        </TabPage>
      </Box>
    );
  }

  function render_DataGrid(): React.ReactNode {
    const columns: GridColDef<HisRowDto>[] = [
      { field: '作業編號', headerName: '特作', width: 70, description: '', editable: true },
      { field: '類別', headerName: '類別(章節)', width: 120, description: '', editable: true },
      { field: '項目', headerName: '項目(題號)', width: 120, description: '', editable: true },
      {
        field: '結果', headerName: '結果(勾選)', width: 480, description: '', editable: true,
        renderCell: render_結果(),
      },
      {
        field: '備註', headerName: '備註(文字部分)', width: 480, description: '', editable: true,
        renderCell: render_ToolTipCell(),
      },
    ];

    // FIXME 合併3個 render
    function render_結果() {
      return (params: any) => {

        let data = params.row as HisRowDto;

        if (data.類別 === "4" && data.項目 === "1") {
          // 既往病史
          if (data.作業編號 === SpwkUtil.CODE_A98) {
            return (
              <Tooltip title={params.value}>
                <Label>{params.value}</Label>
              </Tooltip>
            )
          } else {
            return (
              <Tooltip title={params.value}>
                <Label color="#FF0000" bgcolor={"#FFDDDD"} onClick={() => 結果Click(SpwkUtil.CHAPTER_既往病史, params)}>{params.value}</Label>
              </Tooltip>
            );
          }
        } else if (data.類別 === "6" && data.項目 === "1") {
          // 自覺症狀
          if (data.作業編號 === SpwkUtil.CODE_A98) {
            return (
              <Tooltip title={params.value}>
                <Label>{params.value}</Label>
              </Tooltip>
            )
          } else {
            return (
              <Tooltip title={params.value}>
                <Label color="#0000FF" bgcolor={"#DDDDFF"} onClick={() => 結果Click(SpwkUtil.CHAPTER_自覺症狀, params)}>{params.value}</Label>
              </Tooltip>
            );
          }
        } else {
          return (
            <Tooltip title={params.value}>
              <Label>{params.value}</Label>
            </Tooltip>
          );
        }


      }
    }

    // FIXME 之後處理 寫死的 {_1_}、"4_"、"6_"... 之類的東西
    function 結果Click(sel_chapter: string, params: any) {

      let data = params.row as HisRowDto;
      // 與此特作 此 章節有關的題目
      let meta_list = CurrInfo?.ExportBundle?.AllMetaDataList.filter(
        x => x.func_code === data.作業編號 &&
          x.chapter === sel_chapter
      );

      let his_code_list = data.結果?.split(",") ?? [];

      let re = [];
      for (const his_code of his_code_list) {
        let find_meta = meta_list?.find(x => x.his_code === his_code);
        let opt = find_meta?.data_obj as UniOption;
        let val = opt?.option_title ?? "???";
        if (opt.Inputs?.length === 1) {
          let input_val = find_option_input_val(his_code, data.備註);
          val = val.replace("{_1_}", ":" + (input_val ?? "______"));
        }

        re.push(val);
      }
      let result = '';

      if (re != null) {
        result = re.filter(x => x !== "無").join("、");
        if (result === "") {
          result = "以上皆無";
        }
      }
      navigator.clipboard.writeText(result);

      Toast.Show(ctx, "已複製到剪貼簿。 " + sel_chapter);
    }

    function find_option_input_val(his_code: string, 備註: string | undefined) {
      備註 = 備註 ?? "";

      let splits = 備註.split("@");

      let find_str = splits.find(x => x.startsWith("4_" + his_code + "#") || x.startsWith("6_" + his_code + "#"));

      find_str = find_str?.replace("4_" + his_code + "#", "").replace("6_" + his_code + "#", "");

      return find_str;
    }


    const dataWithId = data_list.map((data, index) => ({ ...data, id: index + 1 }));

    return (
      <div style={linear_content_style}>
        <DataGrid
          style={{ width: "100%", backgroundColor: "white", padding: "12px" }}
          rows={dataWithId}
          columns={columns}

          localeText={DGV_LOCAL_TEXT}// 中文

          components={{
            Toolbar: () => {
              return (<UcDgvCustomToolbar>
                <IconButton onClick={() => { Toast.Show(ctx, "More") }} ><MoreVertIcon /></IconButton>
              </UcDgvCustomToolbar>);
            },
            Pagination: () => {
              return <UcDgvCustomPagination />
            },
          }}

          density={"compact"}
          pageSize={100}
          rowsPerPageOptions={[100]}
          hideFooterSelectedRowCount
          // hideFooter

          onCellEditCommit={async ({ id, field, value }) => { }}
        />
      </div>
    );

  }

}

export default UcHisRowDto